import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AssetsService {

  constructor(private http: HttpClient) {
  }


  getPhonecode(): Observable<Phonecodes[]> {
    const URL = window.location.origin + '/assets/js/intphonecode.json';
    return this.http.get<Phonecodes[]>(URL);
  }

  getCurrency() {
    const URL = 'https://products.akaun.net/assets/js/currency.json';
    return this.http.get(URL);
  }

  getcountries() {
    //const URL = window.location.origin + '/assets/js/countries.json';
    const URL = 'https://api.akaun.com/core2/platform/dm/country';
    return this.http.get(URL);
  }

  getStates() {
    const URL = window.location.origin + '/assets/js/states.json';
    return this.http.get(URL);
  }

  getNationalities() {
    const URL = 'https://products.akaun.net/assets/js/nationalities.json';
    return this.http.get(URL);
  }

  getLanguages() {
    const URL = window.location.origin + '/assets/js/languages.json';
    return this.http.get(URL);
  }
}

export interface Phonecodes {
  countries: Phonecode;
}

export interface Phonecode {
  code: string;
  name: string;
}

export interface states {
  name: string;
  id: number;
  country_id: number;
}

export interface Country {
  name: string;
  id: number;
  sortname?: string;
  phonecode?: number;
}

export interface Language {
  name: string;
}

export interface Nationality {
  nationalities: string;
  upperNationality: string;
}


